import styled from "styled-components";

export const GeneralBusinessBtnWrapper = styled.div`
  display: flex;
  grid-gap: 20px;
  align-items: center;
  flex-wrap: wrap;
`;
